import React from 'react';
import PropTypes from 'prop-types';

import BaseSuccessfulAddSnackbar from 'components/BaseSuccessfulAddSnackbar';
import { buildCartPath } from 'catering/helpers/paths';

const SuccessfulAddSnackbar = ({
  open,
  item,
  cartQuantity,
  subtotal,
  cartItems,
  addedItemImage,
  locationSlug,
  onClose
}) => {
  return (
    <BaseSuccessfulAddSnackbar
      open={open}
      item={item}
      cartQuantity={cartQuantity}
      subtotal={subtotal}
      cartItems={cartItems}
      addedItemImage={addedItemImage}
      handleClose={onClose}
      to={buildCartPath(locationSlug)}
      handleSnackbarCloseOnViewCartClick={onClose}
    />
  );
};

SuccessfulAddSnackbar.propTypes = {
  item: PropTypes.string.isRequired,
  open: PropTypes.bool,
  cartQuantity: PropTypes.number,
  subtotal: PropTypes.string,
  cartItems: PropTypes.array,
  addedItemImage: PropTypes.object,
  locationSlug: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default SuccessfulAddSnackbar;
